import {
  Snackbar,
  Alert,
  CircularProgress,
  Backdrop,
  Icon,
  Card,
  TextField,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Switch,
  Tooltip,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  // Grid,
} from "@mui/material";

import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import DataTable from "theme/Tables/DataTable";
import axios from "axios.js";

import { useAuthUser } from "react-auth-kit";

import AppConfig from "appConfig";
import usePageTitle from "app/pageTitle";

function AccountProduct() {
  const title = "Edit Product";
  usePageTitle(title);

  const navigate = useNavigate();

  const { id } = useParams();

  const auth = useAuthUser();
  const accountInfo = auth();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [refreshPage, setRefreshPage] = useState(false);

  const [product, setProduct] = useState(null);
  const [productTitle, setProductTitle] = useState(null);
  const [productDescription, setProductDescription] = useState(null);
  // const [productAttributes, setProductAttributes] = useState(null);
  const [productAmount, setProductAmount] = useState(null);
  const [productExternalReference, setProductExternalReference] = useState(null);
  const [productAvailabilityEndpoint, setProductAvailabilityEndpoint] = useState(null);
  const [productVariants, setProductVariants] = useState([]);
  const [productImages, setProductImages] = useState([]);
  const [uploadFile, setUploadFile] = useState(null);
  const [openUploadProductImagesDialog, setOpenUploadProductImagesDialog] = useState(false);

  const [selectedVariant, setSelectedVariant] = useState(null);
  const [variantTitle, setVariantTitle] = useState(null);
  const [variantOptions, setVariantOptions] = useState(null);
  const [openAddVariantDialog, setOpenAddVariantDialog] = useState(false);
  const [openEditVariantDialog, setOpenEditVariantDialog] = useState(false);

  const [variantOptionTitle, setVariantOptionTitle] = useState(null);
  const [showVariantOptionTitle, setShowVariantOptionTitle] = useState(false);

  const [openUploadProductItemsDialog, setOpenUploadProductItemsDialog] = useState(false);
  const [inventoryManagementType, setInventoryManagementType] = useState(null);

  async function deleteProductVariant(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/products/variants/${ref}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function updateProductVariantStatus(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/products/variants/${ref}/status.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteProductVariantOption(ref) {
    setOpenEditVariantDialog(false);
    setShowLoading(true);
    await axios
      .get(`/portal/products/variants/options/${ref}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function updateProductVariantOptionStatus(ref) {
    setOpenEditVariantDialog(false);
    setShowLoading(true);
    await axios
      .get(`/portal/products/variants/options/${ref}/status.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteProductImage(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/products/images/${ref}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  const productVariantsTableColumns = [
    { Header: "Option", accessor: "variant", align: "left" },
    { Header: "Choices", accessor: "options", align: "left" },
    { Header: "Actions", accessor: "actions", align: "right" },
    // { Header: "Added On", accessor: "created", align: "center" },
  ];

  const buildProductVariantsRows = (data) => {
    const rows = [];
    data.map((row) => {
      let opts = "";
      row.options.every((opt) => {
        opts += `${opt.title}, `;
        return true;
      });

      rows.push({
        variant: row.title,
        options: opts.trimEnd().replace(/,+$/, ""),
        actions: (
          <MDBox mt={1} variant="button">
            <MDButton
              size="small"
              variant="outlined"
              color="warning"
              iconOnly
              onClick={() => {
                setSelectedVariant(row);
                setVariantTitle(row.title);
                setShowVariantOptionTitle(false);
                setVariantOptionTitle(null);
                setOpenEditVariantDialog(true);
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                edit
              </Icon>
            </MDButton>
            &nbsp;
            <MDButton
              size="small"
              variant="outlined"
              color="info"
              iconOnly
              onClick={() => {
                updateProductVariantStatus(row.reference);
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                {row.status ? "pause" : "play_arrow"}
              </Icon>
            </MDButton>
            &nbsp;
            <MDButton
              size="small"
              variant="outlined"
              color="error"
              iconOnly
              onClick={() => {
                if (window.confirm(`Delete option?`) === true) {
                  deleteProductVariant(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                delete
              </Icon>
            </MDButton>
          </MDBox>
        ),
        // created: row.created,
      });
      return null;
    });

    return rows;
  };

  const productImagesTableColumns = [
    { Header: "Image", accessor: "image", align: "left" },
    { Header: "Actions", accessor: "actions", align: "right" },
    // { Header: "Added On", accessor: "created", align: "center" },
  ];

  const buildProductImagesRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        image: (
          <MDBox>
            <img width="64px" src={`${AppConfig.api_media_url}${row.image}`} alt="img" />
          </MDBox>
        ),
        actions: (
          <MDBox mt={1} variant="button">
            <MDButton
              size="small"
              variant="outlined"
              color="error"
              iconOnly
              onClick={() => {
                if (window.confirm(`Delete image?`) === true) {
                  deleteProductImage(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                delete
              </Icon>
            </MDButton>
          </MDBox>
        ),
        // created: row.created,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`portal/products/${id}/fetch.json`)
        .then((result) => {
          setShowLoading(false);
          if (result.data.status === "success") {
            setProduct(result.data.data.product);
            setProductTitle(result.data.data.product.title);
            setProductDescription(result.data.data.product.description);
            // setProductAttributes(result.data.data.product.attributes);
            setProductAmount(result.data.data.product.price / 100);
            setProductExternalReference(result.data.data.product.external_reference);
            setProductAvailabilityEndpoint(result.data.data.product.availability_endpoint);
            const variantRows = buildProductVariantsRows(result.data.data.product.variants);
            setProductVariants(variantRows);
            const pArows = buildProductImagesRows(result.data.data.product.images);
            setProductImages(pArows);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  function fileSelected(e) {
    e.persist();
    const fileTypes = ["jpeg", "jpg", "png"];
    const file = e.target.files[0];
    const extension = file.name.split(".").pop().toLowerCase();
    const supported = fileTypes.indexOf(extension) > -1;
    if (!supported) {
      setSeverity("error");
      setErrMsg("File type not supported");
      setOpen(true);
      return;
    }

    setUploadFile(e.target.files[0]);
  }

  async function uploadImages() {
    if (uploadFile === null) {
      return;
    }

    const formData = new FormData();
    formData.append("images", uploadFile);
    formData.append("product", id);

    console.log(formData);
    setOpenUploadProductImagesDialog(false);
    setShowLoading(true);
    await axios
      .post("portal/products/images/upload.json", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.status === "success") {
          setSeverity("success");
          setErrMsg(response.data.data.message);
          setOpen(true);
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
        setShowLoading(false);
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  }

  async function editProduct() {
    if (productTitle === null) {
      setSeverity("error");
      setErrMsg("Product name is required.");
      setOpen(true);
      return;
    }

    if (productDescription === null) {
      setSeverity("error");
      setErrMsg("Product description is required.");
      setOpen(true);
      return;
    }

    if (productAmount === null) {
      setSeverity("error");
      setErrMsg("Product price is required.");
      setOpen(true);
      return;
    }

    setShowLoading(true);
    const json = {
      reference: product.reference,
      title: `${productTitle}`,
      description: `${productDescription}`,
      price: parseInt(productAmount, 10) * 100,
    };

    await axios
      .post("portal/products/modify.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function addVariant() {
    if (variantTitle === null) {
      setSeverity("error");
      setErrMsg("Option name is required.");
      setOpen(true);
      return;
    }

    if (variantOptions === null) {
      setSeverity("error");
      setErrMsg("Option choices are required.");
      setOpen(true);
      return;
    }

    const choices = [];
    variantOptions.split(",").forEach((row) => {
      // choices.push(row.replace(/ /g, ""));
      choices.push(row.trimStart().trimEnd());
    });

    if (choices.length <= 0) {
      setSeverity("error");
      setErrMsg("Option choices are required.");
      setOpen(true);
      return;
    }

    setOpenAddVariantDialog(false);
    setShowLoading(true);

    const json = {
      reference: product.reference,
      title: `${variantTitle}`,
      options: choices,
    };
    await axios
      .post("portal/products/variants/create.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function editVariant(ref) {
    if (variantTitle === null) {
      setSeverity("error");
      setErrMsg("Option name is required.");
      setOpen(true);
      return;
    }

    setOpenEditVariantDialog(false);
    setShowLoading(true);

    const json = {
      reference: ref,
      title: `${variantTitle}`,
    };
    await axios
      .post("portal/products/variants/modify.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function addVariantOption(ref) {
    if (variantOptionTitle === null) {
      setSeverity("error");
      setErrMsg("Choice name is required.");
      setOpen(true);
      return;
    }

    setOpenEditVariantDialog(false);
    setShowLoading(true);

    const json = {
      reference: ref,
      title: `${variantOptionTitle}`,
    };
    await axios
      .post("portal/products/variants/options/add.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function postProductObjects(formData) {
    setShowLoading(true);
    await axios
      .post("portal/products/objects/upload.json", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.status === "success") {
          setSeverity("success");
          setErrMsg("Upload successful.");
          setOpen(true);
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
        setShowLoading(false);
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  }

  const uploadProductObjects = () => {
    if (!uploadFile) {
      return;
    }
    const formData = new FormData();
    formData.append("product", product.reference);
    formData.append("file", uploadFile);

    // console.log(formData)
    setOpenUploadProductItemsDialog(false);
    setShowLoading(true);

    postProductObjects(formData);
  };

  function fileSelectedItems(e, any = false) {
    e.persist();
    if (!any) {
      const fileTypes = ["xlsx", "xls", "csv"];
      const file = e.target.files[0];
      const extension = file.name.split(".").pop().toLowerCase();
      const supported = fileTypes.indexOf(extension) > -1;
      if (!supported) {
        setSeverity("error");
        setErrMsg("Only excel and csv files accepted.");
        setOpen(true);
        return;
      }
    }

    setUploadFile(e.target.files[0]);
  }

  async function purgeProductItems() {
    setShowLoading(true);
    await axios
      .get(`/portal/products/${product.reference}/objects/purge.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function setInventoryManagementOption() {
    if (inventoryManagementType === null) {
      setSeverity("error");
      setErrMsg("An option is required.");
      setOpen(true);
      return;
    }

    if (
      window.confirm("This action can not be undone! Are you sure you want to proceed?") === false
    ) {
      return;
    }

    setShowLoading(true);

    const json = {
      reference: product.reference,
      option: inventoryManagementType,
    };
    await axios
      .post("portal/products/inventory/management/create.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function editAPIDetails() {
    if (productExternalReference === null) {
      setSeverity("error");
      setErrMsg("Provide your platform's unique reference for this product.");
      setOpen(true);
      return;
    }

    if (productAvailabilityEndpoint === null) {
      setSeverity("error");
      setErrMsg("A availability endpoint is required for product in-stock checks.");
      setOpen(true);
      return;
    }

    setShowLoading(true);
    const json = {
      reference: product.reference,
      external_reference: productExternalReference,
      availability_endpoint: productAvailabilityEndpoint,
    };

    await axios
      .post("portal/products/inventory/management/api/modify.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function updateProductStatus() {
    setShowLoading(true);
    await axios
      .get(`/portal/products/${product.reference}/status/update.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteProduct() {
    setShowLoading(true);
    await axios
      .get(`/portal/products/${product.reference}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openAddVariantDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Add Product Option</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={2}>
              <MDInput
                value={variantTitle}
                placeholder="Ex. Color, Size, Weight"
                name="option_name"
                margin="dense"
                label="Option Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setVariantTitle(e.target.value)}
              />
            </MDBox>
            <MDBox mt={3}>
              <MDInput
                multiline
                minRows={2}
                value={variantOptions}
                placeholder="Comma separated values; Red, Green, Blue, Black"
                name="choices"
                margin="dense"
                label="Choices"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setVariantOptions(e.target.value)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenAddVariantDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              addVariant();
            }}
          >
            Save
          </MDButton>
        </DialogActions>
      </Dialog>

      {selectedVariant !== null ? (
        <Dialog open={openEditVariantDialog} fullWidth maxWidth="xs">
          <DialogTitle>
            <MDBox>Edit Product Option</MDBox>
          </DialogTitle>
          <DialogContent>
            <MDBox mt={1} mb={3}>
              <MDBox mt={0}>
                <MDInput
                  value={variantTitle}
                  name="option_name"
                  margin="dense"
                  label="Option Name"
                  type="text"
                  fullWidth
                  variant="outlined"
                  onChange={(e) => setVariantTitle(e.target.value)}
                />
                <MDBox align="right" mt={1}>
                  <MDButton
                    size="small"
                    variant="contained"
                    color="dark"
                    onClick={() => {
                      editVariant(selectedVariant.reference);
                    }}
                  >
                    Change Name
                  </MDButton>
                </MDBox>
              </MDBox>
              <MDBox mt={3} p={1}>
                <ListItem sx={{ py: 1, px: 0 }}>
                  <ListItemText
                    sx={{ mr: 2 }}
                    primary={
                      <MDTypography variant="caption" fontWeight="regular">
                        Choices
                      </MDTypography>
                    }
                  />
                  <MDBox align="right">
                    <MDButton
                      size="small"
                      variant="outlined"
                      color="dark"
                      iconOnly
                      onClick={() => {
                        setShowVariantOptionTitle(!showVariantOptionTitle);
                      }}
                    >
                      <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                        {showVariantOptionTitle ? "undo" : "add"}
                      </Icon>
                    </MDButton>
                  </MDBox>
                </ListItem>
                {showVariantOptionTitle === false ? (
                  <MDBox mt={0} p={1}>
                    <List>
                      {selectedVariant.options.map((option) => (
                        <ListItem sx={{ py: 1, px: 0 }}>
                          <ListItemText
                            sx={{ mr: 2 }}
                            primary={
                              <MDTypography variant="h6" fontWeight="light">
                                {option.title}
                              </MDTypography>
                            }
                          />
                          <MDBox align="right">
                            <MDButton
                              size="small"
                              variant="outlined"
                              color="info"
                              iconOnly
                              onClick={() => {
                                updateProductVariantOptionStatus(option.reference);
                              }}
                            >
                              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                                {option.status ? "pause" : "play_arrow"}
                              </Icon>
                            </MDButton>
                            &nbsp;
                            <MDButton
                              size="small"
                              variant="outlined"
                              color="error"
                              iconOnly
                              onClick={() => {
                                if (window.confirm(`Delete choice?`) === true) {
                                  deleteProductVariantOption(option.reference);
                                }
                              }}
                            >
                              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                                delete
                              </Icon>
                            </MDButton>
                          </MDBox>
                        </ListItem>
                      ))}
                    </List>
                  </MDBox>
                ) : (
                  <MDBox mt={2}>
                    <MDInput
                      value={variantOptionTitle}
                      name="option_name"
                      margin="dense"
                      label="Choice Name"
                      type="text"
                      fullWidth
                      variant="outlined"
                      onChange={(e) => setVariantOptionTitle(e.target.value)}
                    />
                    <MDBox align="right" mt={1}>
                      <MDButton
                        size="small"
                        variant="contained"
                        color="dark"
                        onClick={() => {
                          addVariantOption(selectedVariant.reference);
                        }}
                      >
                        Add Choice
                      </MDButton>
                    </MDBox>
                  </MDBox>
                )}
              </MDBox>
            </MDBox>
          </DialogContent>
          <DialogActions>
            <MDButton
              circular
              iconOnly
              onClick={() => {
                setOpenEditVariantDialog(false);
              }}
              color="dark"
              variant="outlined"
            >
              <Icon>close</Icon>
            </MDButton>
          </DialogActions>
        </Dialog>
      ) : (
        <> </>
      )}
      <Dialog open={openUploadProductImagesDialog}>
        <DialogTitle>
          <MDBox>Upload Product Images</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={4}>
              <TextField
                accept=".png, .jpg, .jpeg"
                type="file"
                multiple="multiple"
                name="upload_file"
                id="upload_file"
                // onChange={handleFileInputChange}
                onChange={(e) => fileSelected(e)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenUploadProductImagesDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              uploadImages();
            }}
          >
            Upload
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openUploadProductItemsDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Upload Product Items</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={3} mb={3}>
            <MDBox>
              <TextField
                fullWidth
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                type="file"
                name="upload_file"
                id="upload_file"
                // onChange={handleFileInputChange}
                onChange={(e) => fileSelectedItems(e)}
              />
              <MDTypography p={1} mt={1} variant="subtitle2" fontSize={12} color="info">
                <Icon>info</Icon>&nbsp;Column names contained in file will represent your product
                attributes appearing on receipts sent to your customers.
              </MDTypography>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenUploadProductItemsDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              uploadProductObjects();
            }}
          >
            Upload Items
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox pt={1.5} pb={3} mb={3}>
        {product !== null && (
          <MDBox>
            <MDBox>
              <Card sx={{ width: "100%", marginTop: "10px" }}>
                <MDBox mt={1}>
                  <MDBox p={2} pl={3} display="flex" justifyContent="space-between">
                    <MDBox>
                      <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                        Edit Product Information
                      </MDTypography>
                      <MDTypography variant="caption" fontWeight="regular">
                        Reference: {product.reference}
                      </MDTypography>
                    </MDBox>
                    <MDBox>
                      <Tooltip title="Go Back">
                        <MDButton
                          variant="contained"
                          color="dark"
                          iconOnly
                          onClick={() => navigate("/products")}
                        >
                          <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                            west
                          </Icon>
                        </MDButton>
                      </Tooltip>
                      &nbsp;
                      <Tooltip title={`${product.status ? "Disable" : "Enable"} product`}>
                        <MDButton
                          variant="contained"
                          color="info"
                          iconOnly
                          onClick={() => {
                            if (
                              window.confirm(
                                `${product.status ? "Disable" : "Enable"} this product?`
                              ) === true
                            ) {
                              updateProductStatus();
                            }
                          }}
                        >
                          <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                            {product.status ? "pause" : "play_arrow"}
                          </Icon>
                        </MDButton>
                      </Tooltip>
                      &nbsp;
                      <MDButton
                        variant="contained"
                        color="error"
                        iconOnly
                        onClick={() => {
                          if (window.confirm(`Delete product?`) === true) {
                            deleteProduct();
                          }
                        }}
                      >
                        <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                          delete
                        </Icon>
                      </MDButton>
                    </MDBox>
                  </MDBox>
                  <MDBox p={3}>
                    <MDBox mt={0}>
                      <MDInput
                        value={productTitle}
                        placeholder="Product Name"
                        name="title"
                        margin="dense"
                        label="Name"
                        type="text"
                        fullWidth
                        variant="outlined"
                        onChange={(e) => setProductTitle(e.target.value)}
                      />
                    </MDBox>
                    <MDBox mt={3}>
                      <MDInput
                        value={productDescription}
                        multiline
                        minRows={3}
                        name="description"
                        margin="dense"
                        label="Description"
                        type="text"
                        fullWidth
                        variant="outlined"
                        placeholder="Comprehensive description displayed to customers."
                        onChange={(e) => setProductDescription(e.target.value)}
                      />
                    </MDBox>
                    <MDBox mt={3}>
                      <MDInput
                        value={productAmount}
                        name="price"
                        margin="dense"
                        label="Price"
                        type="text"
                        fullWidth
                        variant="outlined"
                        onChange={(e) => setProductAmount(e.target.value)}
                      />
                    </MDBox>
                    <MDBox mt={3} mb={3}>
                      <Divider />
                    </MDBox>
                    <MDBox mt={3}>
                      <MDBox mt={5} align="right">
                        <MDButton
                          color="dark"
                          variant="contained"
                          onClick={() => {
                            editProduct();
                          }}
                        >
                          Save Changes
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
            <MDBox mt={5}>
              <Card sx={{ width: "100%", marginTop: "10px" }}>
                <MDBox mt={1}>
                  <MDBox p={2} pl={3}>
                    <MDBox display="flex" justifyContent="space-between" alignItems="center">
                      <MDBox>
                        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                          Product Options
                        </MDTypography>
                      </MDBox>
                      <MDButton
                        variant="contained"
                        color="dark"
                        iconOnly
                        onClick={() => {
                          setSelectedVariant(null);
                          setVariantTitle(null);
                          setVariantOptions(null);
                          setOpenAddVariantDialog(true);
                        }}
                      >
                        <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                      </MDButton>
                    </MDBox>
                  </MDBox>
                  <MDBox p={2}>
                    <DataTable
                      table={{ columns: productVariantsTableColumns, rows: productVariants }}
                      isSorted={false}
                      canSearch={false}
                      entriesPerPage={false}
                      showTotalEntries={false}
                      buttons
                      noEndBorder
                    />
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
            <MDBox mt={5}>
              <Card sx={{ width: "100%", marginTop: "10px" }}>
                <MDBox mt={1}>
                  <MDBox p={2} pl={3}>
                    <MDBox display="flex" justifyContent="space-between" alignItems="center">
                      <MDBox>
                        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                          Product Images
                        </MDTypography>
                      </MDBox>
                      <MDButton
                        variant="contained"
                        color="dark"
                        iconOnly
                        onClick={() => {
                          setUploadFile(null);
                          setOpenUploadProductImagesDialog(true);
                        }}
                      >
                        <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                      </MDButton>
                    </MDBox>
                  </MDBox>
                  <MDBox p={2}>
                    <DataTable
                      table={{ columns: productImagesTableColumns, rows: productImages }}
                      isSorted={false}
                      canSearch={false}
                      entriesPerPage={false}
                      showTotalEntries={false}
                      buttons
                      noEndBorder
                    />
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
            <MDBox mt={5}>
              <Card sx={{ width: "100%", marginTop: "10px" }}>
                <MDBox mt={1}>
                  <MDBox p={2} pl={3}>
                    <MDBox display="flex" justifyContent="space-between" alignItems="center">
                      <MDBox>
                        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                          Inventory Management
                        </MDTypography>
                      </MDBox>
                      <MDBox>
                        <Switch
                          color={product.managed_inventory ? "success" : "error"}
                          defaultChecked={product.managed_inventory}
                          disabled
                          // onChange={() => updateStatus()}
                          // inputProps={{ "aria-label": "controlled" }}
                        />
                      </MDBox>
                    </MDBox>
                  </MDBox>
                  {!product.managed_inventory ? (
                    <MDBox p={2}>
                      {product.inventory_source === null ? (
                        <MDBox>
                          <MDBox px={2}>
                            <FormControl>
                              <FormLabel id="demo-radio-buttons-group-label">
                                <MDTypography
                                  variant="subtitle2"
                                  fontSize={14}
                                  fontWeight="regular"
                                >
                                  How do you want to manage stock/inventory?
                                </MDTypography>
                              </FormLabel>
                              <RadioGroup
                                onChange={(e) => setInventoryManagementType(e.target.value)}
                              >
                                <FormControlLabel
                                  value="LADDAR"
                                  control={<Radio />}
                                  label={
                                    <MDTypography variant="subtitle2" fontSize={14}>
                                      Managed On Laddar. (Ideal for items like vouchers, tickets,
                                      and other digital products/services.)
                                    </MDTypography>
                                  }
                                />
                                <FormControlLabel
                                  value="CLIENT"
                                  control={<Radio />}
                                  label={
                                    <MDTypography variant="subtitle2" fontSize={14}>
                                      Managed via API (Requires integration to your inventory
                                      management software)
                                    </MDTypography>
                                  }
                                />
                              </RadioGroup>
                            </FormControl>
                          </MDBox>
                          <MDBox mt={5} mb={2} align="right">
                            <MDButton
                              color="dark"
                              variant="contained"
                              onClick={() => {
                                setInventoryManagementOption();
                              }}
                            >
                              Save Changes
                            </MDButton>
                          </MDBox>
                        </MDBox>
                      ) : (
                        <MDBox p={1}>
                          <MDTypography variant="subtitle2">
                            Inventory management is currently turned off for this product.
                          </MDTypography>
                        </MDBox>
                      )}
                    </MDBox>
                  ) : (
                    <MDBox p={2}>
                      {product.inventory_source === "LADDAR" ? (
                        <MDBox>
                          <MDBox p={1}>
                            <MDTypography variant="h6" fontSize={14} fontWeight="regular">
                              Managed On Laddar
                            </MDTypography>
                            <MDTypography variant="h6" fontSize={14} fontWeight="light">
                              Upload your product items such as tickets, vouchers, barcodes and
                              product IDs. Laddar manages dispensing and tracking of items to your
                              customers.
                            </MDTypography>
                          </MDBox>
                          <MDBox mt={2} mb={3} display="flex" justifyContent="space-between" p={1}>
                            <MDBox>
                              <MDTypography variant="h6" fontSize={14} fontWeight="regular">
                                Stock Information
                              </MDTypography>
                              <MDTypography variant="h6" fontSize={14} fontWeight="light">
                                Total:&nbsp;<b>{product.item_count.total}</b>&nbsp; |
                                &nbsp;Assigned:&nbsp;
                                <b>{product.item_count.used}</b>
                                &nbsp; | Available:&nbsp;
                                <b>{product.item_count.total - product.item_count.used}</b>
                              </MDTypography>
                            </MDBox>
                            <MDBox>
                              <Tooltip title="Upload Product Items">
                                <MDButton
                                  size="small"
                                  variant="outlined"
                                  color="success"
                                  iconOnly
                                  onClick={() => {
                                    setOpenUploadProductItemsDialog(true);
                                  }}
                                >
                                  <Icon sx={{ fontWeight: "bold" }}>upload</Icon>
                                </MDButton>
                              </Tooltip>
                              &nbsp;
                              <Tooltip title="Download Product Items">
                                <MDButton
                                  size="small"
                                  variant="outlined"
                                  color="dark"
                                  iconOnly
                                  onClick={() => {
                                    if (window.confirm(`Download product items?`) === true) {
                                      const downloadUrl = `${AppConfig.api_base_url}portal/products/${product.reference}/${accountInfo.user.reference}/download.json`;
                                      window.open(downloadUrl, "_blank");
                                    }
                                  }}
                                >
                                  <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                                    download
                                  </Icon>
                                </MDButton>
                              </Tooltip>
                              &nbsp;
                              <Tooltip title="Purge Product Items">
                                <MDButton
                                  size="small"
                                  variant="outlined"
                                  color="error"
                                  iconOnly
                                  onClick={() => {
                                    if (
                                      window.confirm(
                                        "Are you sure you want to purge all product items? This will affect all related campaigns."
                                      ) === true
                                    ) {
                                      purgeProductItems();
                                    }
                                  }}
                                >
                                  <Icon sx={{ fontWeight: "bold" }}>delete_sweep</Icon>
                                </MDButton>
                              </Tooltip>
                            </MDBox>
                          </MDBox>
                        </MDBox>
                      ) : (
                        <MDBox p={1}>
                          <MDBox>
                            <MDTypography variant="h6" fontSize={14} fontWeight="regular">
                              Managed via API
                            </MDTypography>
                            <MDTypography variant="h6" fontSize={14} fontWeight="light">
                              Product inventory is managed by your business&apos;s inventory system
                              and integrated via API.
                            </MDTypography>
                          </MDBox>
                          <MDBox mt={3}>
                            <MDInput
                              value={productExternalReference}
                              placeholder="Eg: SKU, Barcode, Product ID etc"
                              margin="dense"
                              label="Unique Reference"
                              type="text"
                              fullWidth
                              variant="outlined"
                              onChange={(e) => setProductExternalReference(e.target.value)}
                            />
                            <MDTypography variant="text" color="info" pl={1} fontSize="small">
                              <small>
                                <Icon>info</Icon>&nbsp; Identifies this product on your platform.
                                Used in every API request to your platform.
                              </small>
                            </MDTypography>
                          </MDBox>
                          <MDBox mt={2}>
                            <MDInput
                              value={productAvailabilityEndpoint}
                              multiline
                              minRows={2}
                              margin="dense"
                              label="Availability Endpoint"
                              type="text"
                              fullWidth
                              variant="outlined"
                              placeholder="https://YOUR-API-URL"
                              onChange={(e) => setProductAvailabilityEndpoint(e.target.value)}
                            />
                            <MDTypography variant="text" color="info" pl={1} fontSize="small">
                              <small>
                                <Icon>info</Icon>&nbsp; An endpoint to check product availability
                                before sales. If not provided, availability check will be ignored.
                              </small>
                            </MDTypography>
                          </MDBox>
                          <MDBox mt={3}>
                            <MDBox mt={5} mb={2} align="right">
                              <MDButton
                                color="dark"
                                variant="contained"
                                onClick={() => {
                                  editAPIDetails();
                                }}
                              >
                                Save Changes
                              </MDButton>
                            </MDBox>
                          </MDBox>
                        </MDBox>
                      )}
                    </MDBox>
                  )}
                </MDBox>
              </Card>
            </MDBox>
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AccountProduct;
